import familyListStore from '@modules/family/family-list-store';
import familyViewStore from '@modules/family/family-view-store';
import familyImporterStore from '@modules/family/family-importer-store';
import familyFormStore from '@modules/family/family-form-store';
import familyDestroyStore from '@modules/family/family-destroy-store';

export default {
    namespaced: true,

    modules: {
        destroy: familyDestroyStore,
        form: familyFormStore,
        list: familyListStore,
        view: familyViewStore,
        importer: familyImporterStore,
    },
};